import { getResponsiveImageUrls } from "@/utils/imageOptimization";

interface ResponsiveHeroImageProps {
  imageUrl: string;
  alt?: string;
  className?: string;
  priority?: boolean;
}

/**
 * A responsive hero image component that automatically generates srcset
 * for optimal performance on mobile and desktop devices.
 * 
 * Use this for hero sections and large background images that are LCP candidates.
 */
export const ResponsiveHeroImage = ({
  imageUrl,
  alt = "",
  className = "absolute inset-0 h-full w-full object-cover",
  priority = true,
}: ResponsiveHeroImageProps) => {
  const { src, srcSet, sizes } = getResponsiveImageUrls(imageUrl);

  return (
    <img
      src={src}
      srcSet={srcSet || undefined}
      sizes={srcSet ? sizes : undefined}
      alt={alt}
      role="presentation"
      width={1920}
      height={1080}
      fetchPriority={priority ? "high" : "auto"}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className={className}
    />
  );
};
